import React from 'react'
import moment from 'moment'
import 'moment/locale/pt.js'

import omit from 'lodash/omit'
import IconImage from './calendar.svg'
import {
  SingleDatePicker,
  SingleDatePickerPhrases,
  HORIZONTAL_ORIENTATION,
  ANCHOR_LEFT
} from 'react-dates'

moment.locale('pt')

const Icon = () => (<img src={IconImage} alt={`Date`} />)

const defaultProps = {
  disabled: false,
  required: false,
  screenReaderInputMessage: '',
  showClearDate: false,
  showDefaultInputIcon: false,

  // calendar presentation and interaction related props

  orientation: HORIZONTAL_ORIENTATION,
  anchorDirection: ANCHOR_LEFT,
  horizontalMargin: 0,
  withPortal: false,
  withFullScreenPortal: false,
  initialVisibleMonth: null,
  numberOfMonths: 1,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDate: false,
  isRTL: false,

  // navigation related props
  navPrev: null,
  navNext: null,
  onPrevMonthClick () {},
  onNextMonthClick () {},

  // day presentation and interaction related props
  renderDay: null,
  enableOutsideDays: true,
  isDayBlocked: () => false,
  isOutsideRange: day => false,
  isDayHighlighted: () => {},

  // internationalization props
  displayFormat: 'DD/MM/YYYY',

  renderMonth: (month) => {
    month.locale('pt')
    return month.format('MMMM YYYY')
  },
  phrases: SingleDatePickerPhrases,
  customInputIcon: <Icon />
}

class SingleDatePickerWrapper extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      focused: props.autoFocus,
      date: props.value
    }

    this.onDateChange = this.onDateChange.bind(this)
    this.onFocusChange = this.onFocusChange.bind(this)
  }

  onDateChange (date) {
    this.setState({ date })
    this.props.onChange && this.props.onChange({ date })
  }

  onFocusChange ({ focused }) {
    this.setState({ focused })
  }

  componentWillReceiveProps (props) {
    if (props.value !== this.state.date) {
      this.setState({ date: props.value })
    }
  }

  render () {
    const { focused, date } = this.state
    moment.locale('pt')
    // autoFocus and initialDate are helper props for the example wrapper but are not
    // props on the SingleDatePicker itself and thus, have to be omitted.
    let props = omit(this.props, [
      'autoFocus',
      'initialDate',
      'value',
      'onChange'
    ])

    props = { ...defaultProps, ...props }

    return (
      <SingleDatePicker
        {...props}
        date={date}
        focused={focused}
        onDateChange={this.onDateChange}
        onFocusChange={this.onFocusChange}
      />
    )
  }
}

export default SingleDatePickerWrapper



// WEBPACK FOOTER //
// ./src/components/DatePicker/index.js